import { QueryClient } from '@tanstack/react-query';
import { PaginatedResponse } from '../types';

export type PaginatedSnapshot<T> = Array<[readonly unknown[], PaginatedResponse<T> | undefined]>;

export const snapshotPaginatedQueries = <T>(queryClient: QueryClient, resourceKey: string): PaginatedSnapshot<T> =>
  queryClient.getQueriesData<PaginatedResponse<T>>({ queryKey: [resourceKey] });

export const restorePaginatedQueries = <T>(queryClient: QueryClient, snapshots: PaginatedSnapshot<T>) => {
  snapshots.forEach(([queryKey, data]) => queryClient.setQueryData(queryKey, data));
};

export const updatePaginatedQueries = <T>(
  queryClient: QueryClient,
  resourceKey: string,
  update: (page: PaginatedResponse<T>) => PaginatedResponse<T>,
) => {
  queryClient.setQueriesData<PaginatedResponse<T>>({ queryKey: [resourceKey] }, (page: PaginatedResponse<T> | undefined) =>
    page ? update(page) : page,
  );
};

export const updateArrayQueries = <T>(
  queryClient: QueryClient,
  resourceKey: string,
  update: (items: T[]) => T[],
) => {
  queryClient.setQueriesData<T[]>({ queryKey: [resourceKey] }, (items: T[] | undefined) => items ? update(items) : items);
};
